import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NUM DOC' htmlFor='select-numeroDocumento' md={2} />
      <Col md={10}>
        <Field name='numeroDocumento'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-numeroDocumento'
              placeholder='Ingresar número de documento ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
